<template>
<div>
    <b-alert show variant='success' v-if="msg.type == 'success'">
        <p v-for = " (m,i) in msg.arr" :key="i">{{m}}</p>
        <b-button  variant="danger">X</b-button>
    </b-alert>
    <b-alert show variant="danger" v-else>
        <p v-for = " (m,i) in msg.arr" :key="i">{{m}}</p>
        <b-button  variant="danger">X</b-button>
    </b-alert>
    
</div>
</template>

<script>
export default {
    props: ["msg"]

}
</script>

<style scoped>
.btn-danger{
    position: absolute;
    top: 3px;
    right: 3px;
}

</style>
